import React, { Fragment } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { getToken } from '../config/axios.config';
import { getAuthUser } from '../utils/auth.util';

function RedirectRoute({ children }) {
  const location = useLocation();
  const token = getToken();
  const authUser = getAuthUser();

  const isAuthed = Boolean(authUser && token);

  if (isAuthed && location.pathname !== '/dashboard') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Fragment key={location.key}>{children}</Fragment>;
}

export { RedirectRoute };
